/**
 * Threshold in milliseconds beyond which a Samsara GPS ping is considered "stale".
 * After this period without a fresh ping, the vehicle is visually flagged in the
 * In Transit view (sidebar + map) so dispatchers know the dot is not live.
 */
export const STALE_THRESHOLD_MS = 30 * 60 * 1000; // 30 minutes

export function isVehicleStale(v: { lastUpdateIso?: string | null }): boolean {
  if (!v.lastUpdateIso) return true;
  const t = new Date(v.lastUpdateIso).getTime();
  if (Number.isNaN(t)) return true;
  return Date.now() - t > STALE_THRESHOLD_MS;
}